import { render, staticRenderFns } from "./ImportPbnDictionaries.vue?vue&type=template&id=3b181864&scoped=true&"
import script from "./ImportPbnDictionaries.vue?vue&type=script&lang=js&"
export * from "./ImportPbnDictionaries.vue?vue&type=script&lang=js&"
import style0 from "./ImportPbnDictionaries.vue?vue&type=style&index=0&id=3b181864&scoped=true&lang=scss&"
import style1 from "./ImportPbnDictionaries.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b181864",
  null
  
)

export default component.exports